/**
 * Route for `three-tier-pricing-starter-agency-enterprise`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ThreeTierPricingStarterAgencyEnterprisePage } from "../features/three-tier-pricing-starter-agency-enterprise/ThreeTierPricingStarterAgencyEnterprisePage";

export const threeTierPricingStarterAgencyEnterpriseRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/three-tier-pricing-starter-agency-enterprise",
	component: ThreeTierPricingStarterAgencyEnterprisePage,
});

export default threeTierPricingStarterAgencyEnterpriseRoute;
